import { use } from 'react';

import { Grid } from '@mui/material';

import Dimens from '../../../themes/dimens';
import UserActionBar from '../components/userActionBar';
import UserInformationCard from '../components/userInformationCard';
import UserContext from '../providers/userContext';

interface UserDetailsContainerProps {
	userId: string;
	organisationId?: string | undefined | null;
	allowRoleEditing: boolean;
	allowDeleting: boolean;
}

const UserDetailsContainer = ({
	userId,
	organisationId,
	allowRoleEditing,
	allowDeleting,
}: UserDetailsContainerProps) => {
	const userContext = use(UserContext);
	return (
		<>
			<UserActionBar
				userId={userId}
				organisationId={organisationId}
				allowRoleEditing={allowRoleEditing}
				allowDeleting={allowDeleting}
			/>
			<Grid
				container
				spacing={Dimens.spacingXl}
				direction={'row'}
				sx={{
					alignItems: 'stretch',
				}}
			>
				<Grid size={{ xs: 12, md: 8, lg: 6 }}>
					<UserInformationCard user={userContext.user} isLoading={userContext.isLoading} />
				</Grid>
			</Grid>
		</>
	);
};

export default UserDetailsContainer;
